import * as actionTypes from "./actionTypes";
import axios from "axios";

export const initGetMessages = () => {
  return {
    type: actionTypes.INIT_Get_Messages,
    messageLoading: true,
  };
};

export const successGetMessages = (data) => {
  return {
    type: actionTypes.SUCCESS_Get_Messages,
    messages: data,
    messageLoading: false,
  };
};

export const failGetMessages = (error) => {
  return {
    type: actionTypes.FAIL_Get_Messages,
    error: error,
    messageLoading: false,
  };
};

export const getMessages = () => {
  const token = localStorage.getItem("idToken");
  const config = {
    headers: {
      Authorization: "Bearer " + token,
    },
  };
  return (dispatch) => {
    dispatch(initGetMessages());
    axios
      .get("chats", config)
      .then((response) => {
        dispatch(successGetMessages(response.data.data));
      })
      .catch((error) => {
        dispatch(failGetMessages(error.message));
      });
  };
};

// ################ Get All USERS :

export const initAllUsers = () => {
  return {
    type: actionTypes.INIT_ALL_USERS,
    allUsersLoading: true,
  };
};

export const successAllUsers = (data) => {
  return {
    type: actionTypes.SUCCESS_ALL_USERS,
    allUsers: data.data,
    allUsersLoading: false,
  };
};

export const failAllUsers = (error) => {
  return {
    type: actionTypes.FAIL_ALL_USERS,
    error: error,
    allUsersLoading: false,
  };
};

export const getAllUsers = () => {
  const token = localStorage.getItem("idToken");
  const config = {
    headers: {
      Authorization: "Bearer " + token,
    },
  };

  return (dispatch) => {
    dispatch(initAllUsers());
    axios
      .get("users", config)
      .then((respones) => {
        dispatch(successAllUsers(respones.data));
      })
      .catch((error) => {
        dispatch(failAllUsers(error.message));
      });
  };
};
